import axios from "axios";
import React, { useState, useEffect } from "react";
import profile from "../../assets/images/profile.jpg";
import { APIURL } from "../../redux/action/config";
import dateFormat from "dateformat";
import { Formik } from "formik";
import { updateVehicle } from "../../redux/action/customers";
import { useDispatch } from "react-redux";
import { vehicleItems } from "./AddVehicle";

const UpdateVehicle = (props) => {
  const dispatch = useDispatch();
  const vehicle = props.vehicle;
  const userID = props.userID;
  const vehId = props.vehId;

  const [vehicleType, setVehicleType] = useState('')
  useEffect(() => {
    setVehicleType(vehicle?.type)
  }, [vehicle])

  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={props.modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0 d-flex">
              <div className="text-center">
                <h1 className=" text-primary">Vehicle Details</h1>
                {/* <div className="text-muted fw-bold fs-5">
                      If you need more info, please check out.
                    </div> */}
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="modal-body p-0">
                <Formik
                  initialValues={{
                    name: vehicle?.name,
                    year: vehicle?.year,
                    model: vehicle?.model,
                    color: vehicle.color,
                    reg_no: vehicle.reg_no,
                    type: vehicle?.type
                  }}
                  onSubmit={(values) => {
                    values.name = values?.name ? values?.name : vehicle?.name;
                    values.year = values?.year ? values?.year : vehicle?.year;
                    values.model = values?.model
                      ? values?.model
                      : vehicle?.model;
                    values.reg_no = values?.reg_no
                      ? values?.reg_no
                      : vehicle?.reg_no;
                    values.color = values?.color
                      ? values?.color
                      : vehicle?.color;
                    values.type = vehicleType
                    dispatch(updateVehicle({ ...values }, userID, vehId));
                  }}
                >
                  {({ values, handleBlur, handleChange, handleSubmit }) => (
                    <form className="form">
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">Select Vehicle</div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <select
                            className="form-select form-control form-control-solid"
                            aria-label="Select example"
                            onChange={(e) => setVehicleType(e.target.value)}
                            name="type"
                            id="type"
                            value={vehicleType}
                          >
                            <option>Select Vehicle</option>
                            {vehicleItems.map((item) =>
                              <option value={item}>{item}</option>
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">Year</div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="year"
                            id="year"
                            defaultValue={
                              vehicle?.year ? vehicle?.year : values.year
                            }
                          />
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">Vehicle Make</div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="name"
                            id="name"
                            defaultValue={
                              vehicle?.name ? vehicle?.name : values.name
                            }
                          />
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">Vehicle Model</div>
                        </div>
                        <div className="membership-form-check col-xl-9 fv-row fv-plugins-icon-container d-flex flex-wrap checkbox">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="model"
                            id="model"
                            defaultValue={
                              vehicle.model ? vehicle.model : values?.model
                            }
                          />
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">Color</div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="color"
                            id="color"
                            defaultValue={
                              vehicle?.color ? vehicle?.color : values.color
                            }
                          />
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">
                            License Number
                          </div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <textarea
                            rows="3"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="reg_no"
                            id="reg_no"
                            className="form-control form-control-solid"
                            defaultValue={
                              vehicle?.reg_no ? vehicle?.reg_no : values.reg_no
                            }
                          ></textarea>
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="separator mb-6"></div>
                      <div className="d-flex justify-content-end">
                        <button
                          onClick={handleSubmit}
                          type="submit"
                          className="btn btn-primary"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        >
                          <span className="indicator-label">Save</span>
                        </button>
                      </div>
                      <div></div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default UpdateVehicle;
